
































































































































import { clone, cloneDeep } from 'lodash-es';
import changeLogMixin from '@adobe/edex/frontend/views/course/settings/mixin';
import CourseVideo from '@adobe/edex/frontend/views/course/course-video.vue';
import Dropzone from '@adobe/edex/frontend/components/common/file-dropzone.vue';

const MODAL_WIDTH = 656;

const getInitialState = (initialCourse) => ({
  landingImage: cloneDeep(initialCourse.assets.images.landing),
  heroImage: cloneDeep(initialCourse.assets.images.hero),
  heroVideo: cloneDeep(initialCourse.assets.videos.hero),
  enrollmentImage: cloneDeep(initialCourse.assets.images.enrolled),
  passedImage: cloneDeep(initialCourse.assets.images.passed),
  modalFileType: null,
});

export default {
  mixins: [changeLogMixin],
  props: {
    initialCourse: {
      type: Object,
      required: true,
    },
  },
  data() {
    return getInitialState(this.initialCourse);
  },
  components: {
    Dropzone,
  },
  created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  computed: {
    modalContent() {
      switch (this.modalFileType) {
        case 'courseLandingPageImage':
          return {
            title: 'Landing Image',
            onComplete: ({ file }) => {
              this.landingImage.url = file.storagePath;
              this.$modal.hide('course-assets-modal');
            },
          };
        case 'courseHeroImage':
          return {
            title: 'Hero Image',
            onComplete: ({ file }) => {
              this.heroImage.largeURL = file.storagePath;
              this.$modal.hide('course-assets-modal');
            },
          };
        case 'courseEnrollmentImage':
          return {
            title: 'Enrollment Image',
            fileType: this.modalFileType,
            onComplete: ({ file }) => {
              this.enrollmentImage.url = file.storagePath;
              this.$modal.hide('course-assets-modal');
            },
          };
        case 'coursePassedImage':
          return {
            title: 'Passed Image',
            fileType: this.modalFileType,
            onComplete: ({ file }) => {
              this.passedImage.url = file.storagePath;
              this.$modal.hide('course-assets-modal');
            },
          };
        default:
          return { title: '' };
      }
    },
  },
  methods: {
    beforeOpen(e) {
      this.modalFileType = e.params.fileType;
    },
    beforeClose(e) {
      this.modalFileType = null;
    },
    resetChanges() {
      Object.assign(this.$data, getInitialState(this.initialCourse));
    },
  },
  watch: {
    ...['caption', 'url'].reduce((acc, name) => {
      acc[`heroVideo.${name}`] = function (current, previous) {
        if (previous !== current) {
          this.onChange({
            name: `heroVideo.${name}`,
            data: current,
            path: ['assets', 'videos', 'hero', name],
            hasDiff: this.initialCourse.assets.videos.hero[name] !== current,
          });
        }
      };

      return acc;
    }, {}),
    ...['caption', 'url'].reduce((acc, name) => {
      acc[`landingImage.${name}`] = function (current, previous) {
        if (previous !== current) {
          this.onChange({
            name: `landingImage.${name}`,
            data: current,
            path: ['assets', 'images', 'landing', name],
            hasDiff: this.initialCourse.assets.images.landing[name] !== current,
          });
        }
      };

      return acc;
    }, {}),
    ...['caption', 'url'].reduce((acc, name) => {
      acc[`enrollmentImage.${name}`] = function (current, previous) {
        if (previous !== current) {
          this.onChange({
            name: `enrollmentImage.${name}`,
            data: current,
            path: ['assets', 'images', 'enrolled', name],
            hasDiff: this.initialCourse.assets.images.enrolled[name] !== current,
          });
        }
      };
      return acc;
    }, {}),

    ...['caption', 'url'].reduce((acc, name) => {
      acc[`passedImage.${name}`] = function (current, previous) {
        if (previous !== current) {
          this.onChange({
            name: `passedImage.${name}`,
            data: current,
            path: ['assets', 'images', 'passed', name],
            hasDiff: this.initialCourse.assets.images.passed[name] !== current,
          });
        }
      };
      return acc;
    }, {}),

    ...['caption', 'largeURL', 'legacy', 'thumbnail'].reduce((acc, name) => {
      acc[`heroImage.${name}`] = function (current, previous) {
        if (previous !== current) {
          this.onChange({
            name: `heroImage.${name}`,
            data: current,
            path: ['assets', 'images', 'hero', name],
            hasDiff: this.initialCourse.assets.images.hero[name] !== current,
          });
        }
      };

      return acc;
    }, {}),
  },
};
